module.exports = __webpack_public_path__ + "static/img/(1961)_01_22_MinneapolisDIYFlyer.93cf966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/(1961)_01_22_MinneapolisDIYFlyer.jpg
// module id = xM4+
// module chunks = 0